module.exports = __webpack_public_path__ + "static/media/holly-michaels-lose.4246578c.jpg";